export default {
  USER_ENTER_MOBILE_FOR_LOGIN: "USER_ENTER_MOBILE_FOR_LOGIN",
  USER_ENTER_MOBILE_FOR_LOGIN_SUCCESS: "USER_ENTER_MOBILE_FOR_LOGIN_SUCCESS",
  USER_ENTER_MOBILE_FOR_LOGIN_FAILED: "USER_ENTER_MOBILE_FOR_LOGIN_FAILED",

  MOBILE_USER_WRONG: "MOBILE_USER_WRONG",
  SEND_CODE_SMS_TO_USER: "SEND_CODE_SMS_TO_USER",

  CHECK_SMS_CODE_MOBILE_FOR_LOGIN: "CHECK_SMS_CODE_MOBILE_FOR_LOGIN",
  CHECK_SMS_CODE_MOBILE_FOR_LOGIN_SUCCESS:
    "CHECK_SMS_CODE_MOBILE_FOR_LOGIN_SUCCESS",
  CHECK_SMS_CODE_MOBILE_FOR_LOGIN_FAILED:
    "CHECK_SMS_CODE_MOBILE_FOR_LOGIN_FAILED",

  CHECK_USER_LOGIN: "CHECK_USER_LOGIN",
  CHECK_USER_LOGIN_FAILED: "CHECK_USER_LOGIN_FAILED",
  CHECK_USER_LOGIN_SUCCESS: "CHECK_USER_LOGIN_SUCCESS",

  USER_DO_LOGOUT: "USER_DO_LOGOUT",

  SEND_SMS_LOGIN_CODE_AGAIN: "SEND_SMS_LOGIN_CODE_AGAIN",

  USER_REGISTER: "USER_REGISTER",
  USER_REGISTER_SUCCESS: "USER_REGISTER_SUCCESS",
  USER_REGISTER_FAILED: "USER_REGISTER_FAILED",
};
